import type { CSSProperties, ReactNode } from 'react'
import { colorFamilies, type DesignSystemColorFamily } from '../tokens/colors'

/** Solid = saturated fill. Tinted = pale fill. */
export type BadgeMode = 'solid' | 'tinted'

export type BadgeColor = DesignSystemColorFamily

export const BADGE_MODES: BadgeMode[] = ['solid', 'tinted']

export const BADGE_COLORS: BadgeColor[] = [...colorFamilies]

export type BadgeProps = {
  children?: ReactNode
  label?: string
  mode?: BadgeMode
  /**
   * When true, renders the solid (saturated) appearance
   * regardless of `mode`. Prefer this when the badge sits on a dark surface.
   */
  darkMode?: boolean
  color?: BadgeColor
  dismissible?: boolean
  onDismiss?: () => void
  className?: string
  style?: CSSProperties
}
